// Maps the events autocomplete payload (autocomplete.json+event_search.jbuilder)
// onto the quantum-select item shape. Raw rows arrive grouped by type
// ({locations, event_schedules, categories}) and carry
// {text, group, visibility, matchValue?, url?, filters?, icon?}.

// `visibility` partitions the corpus exactly like the legacy autocomplete's
// setData: 'no-query' rows are browse-only, 'query' rows appear only while
// typing, absent means both.
export function buildEventsOmnisearchItems(payload) {
  const rows = Object.values(payload ?? {})
    .flat()
    .filter((row) => row && typeof row === "object");

  const items = rows.map(toItem);
  const searchItems = items.filter((item, index) => rows[index].visibility !== "no-query");

  // Legacy parity: an empty searchable corpus kills the whole dropdown,
  // including the browse list (filterCollection bails on empty queryData).
  if (!searchItems.length) {
    return { idleItems: [], searchItems: [] };
  }

  const idleItems = items.filter((item, index) => rows[index].visibility !== "query");
  return { idleItems, searchItems };
}

// The selectable no-results row, preserved verbatim from the legacy
// autocomplete — including that selecting it echoes this sentence into the
// field. The `fallback` flag makes the pipeline render it only when the query
// matches nothing.
export function apologyItem(query) {
  return {
    title: `We're sorry, we found no results for '${query}'. Please try again.`,
    value: "apology",
    fallback: true,
    payload: {},
  };
}

function toItem(row, index) {
  const item = {
    title: row.text,
    value: String(index),
    payload: {},
  };
  if (row.group != null) {
    item.group = row.group;
  }
  // matchValue replaces the title as the searchable string (legacy semantics) —
  // it must ride as `searchText`, never as a supplemental keyword.
  if (row.matchValue) {
    item.searchText = row.matchValue;
  }
  if (row.url) {
    item.payload.url = row.url;
  }
  // Payload-supplied icon wins; schedule rows keep their calendar for payloads
  // that carry no icon field.
  const icon = row.icon ?? (row.url ? "calendar-filled" : null);
  if (icon) {
    item.props = { prependIcon: icon };
  }
  if (row.filters) {
    item.payload.filters = row.filters;
  }
  return item;
}
